module.exports = __webpack_public_path__ + "img/book_zhuanye.46d2414d.png";